"use client";
import {
  Button,
  ModalDialogBody,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogRoot,
  Text,
} from "@zapier/design-system";

interface ResumeConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ResumeConfirmModal: React.FC<ResumeConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <ModalDialogRoot
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      isDismissable={false}
    >
      <ModalDialogHeader>
        <Text type="SectionHeader" color="TextStronger">
          Resume Live Chat?
        </Text>
      </ModalDialogHeader>
      <ModalDialogBody>
        <Text type="Body1" color="TextDefault">
          Your active live chat is in another copilot conversation. Resuming
          will take you to that conversation.
        </Text>
      </ModalDialogBody>
      <ModalDialogFooter>
        <Button variant="secondary" size="small" onPress={onClose}>
          Cancel
        </Button>
        <Button variant="primary" size="small" onPress={onConfirm}>
          Resume Chat
        </Button>
      </ModalDialogFooter>
    </ModalDialogRoot>
  );
};
